import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <CardsSection />
        <CarouselSection />
        <CommentsSection />
        <AppSection />
        <MediaSection />
        <FaqSection />
        <ContactSection />
        <FeaturesSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <TopicsSection />
        <UpdatesSection />
      </main>
      <Footer />
    </div>
  );
}